/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amarantos API
 * REST API for the Amarantos construction and infrastructure management platform. Supports both the Panel (web) and App (mobile) clients.
 *
 * OpenAPI spec version: 1.0.0
 */

/**
 * Who wrote the row. `system` rows are derived by network recalculation and are read-only over the API; `manual` rows are added by an administrator, and recalculation never creates, edits or deletes them.
 */
export type MaterialProvenance = typeof MaterialProvenance[keyof typeof MaterialProvenance];


export const MaterialProvenance = {
  system: 'system',
  manual: 'manual',
} as const;
